import { render, staticRenderFns } from "./TrackingRecordDelete.vue?vue&type=template&id=fa33c0a6&scoped=true"
import script from "./TrackingRecordDelete.vue?vue&type=script&lang=js"
export * from "./TrackingRecordDelete.vue?vue&type=script&lang=js"
import style0 from "./TrackingRecordDelete.vue?vue&type=style&index=0&id=fa33c0a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa33c0a6",
  null
  
)

export default component.exports